export default __webpack_public_path__ + "static/media/delete_icon.03d890f8.svg";